<template>
    <div class="model-icon--wrapper">
        <div
            class="model-icon"
            :style="iconBackgroundStyles"
        />
        <or-textbox
            class="model-icon--input"
            v-if="editable"
            :placeholder="$t('model.common.model_icon.enterPreviewImageUrl')"
            v-model="customUrl"
        />
    </div>
</template>

<script>
export default {
  props: {
    url: String,
    defaultImage: String,
    editable: Boolean
  },

  computed: {
    customUrl: {
      get () {
        return this.$props.url
      },
      set (newUrl) {
        this.$emit('update:url', newUrl)
      }
    },

    iconBackgroundStyles () {
      let backgroundImage = `url(${this.$props.url})`
      if (this.$props.defaultImage) {
        backgroundImage += `, url(${this.$props.defaultImage})`
      }

      return {
        backgroundImage
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .model-icon--wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .model-icon {
            min-width: 100px;
            min-height: 100px;
            border-radius: 100px;
            margin-right: $sp-5;
            background-color: #DFDFDF;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            &:hover {
                cursor: pointer;
                color: darken($or-grey-dark, 10%);
            }
        }

        .model-icon--input {
            width: 100%;
            margin-bottom: 0;
        }
    }
</style>
